export default {
    workload: {
        add_title: 'Adicionar Carga de Trabalho',
        edit_title: 'Editar Carga de Trabalho',
        finish_title: 'Finalizar Carga de Trabalho',
    },

    app_search: {
        search_placeholder: 'Pesquisar Chamados ou Tarefas',
        search_placeholder_task: 'Pesquisar Tarefas',
        search_placeholder_ticket: 'Pesquisar Chamados',
        search_info: 'Digite o número ou título de um chamado ou tarefa',
        search_info_task: 'Digite o número ou título de uma tarefa',
        search_info_ticket: 'Digite o número ou título de um chamado',
    },
}
